import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LanguageOpt, LanguageSwitch } from "./commonUi.styles";
import dayjs from "dayjs";
import "dayjs/locale/de";
import "dayjs/locale/en";

const LanguageOption = ({ lang }: { lang: string }) => {
    const { i18n } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const handleSwitchLanguage = (lang: string) => {
        i18n.changeLanguage(lang);
        const path = location.pathname.split("/").slice(2).join("/");

        dayjs.locale(lang)
        navigate(`/${lang}/${path}${location.search}`);
    };
    return (
        <LanguageOpt
            sx={{
                color: (i18n.language === lang) ? "white" : "text.primary",
                backgroundColor: (i18n.language === lang) ? "primary.main" : "transparent",
            }}
            onClick={() => handleSwitchLanguage(lang)}
        >
            {lang.toUpperCase()}
        </LanguageOpt>
    )
}

const LanguageSwitcher = () => {
    return (
        <LanguageSwitch defaultChecked >
            <LanguageOption lang="en"/>
            <LanguageOption lang="de"/>
        </LanguageSwitch>
    )
}

export default LanguageSwitcher